/**
 * Represents the channel through which an order was placed.
 *
 * - **ONLINE**: Orders placed through digital channels (web, mobile app) via EVA
 * - **STATIONARY**: Orders placed at physical retail stores (POS/Bons)
 */
export enum OrderChannel {
  ONLINE = "ONLINE",
  STATIONARY = "STATIONARY",
}
